// Lightweight production-aware logger.
// Silences console output in production builds; passes through in dev.
// Errors are still surfaced in production so they remain visible to Sentry-style tools.

const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

export const logger = {
  log: isProd ? noop : (...args) => console.log(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  warn: isProd ? noop : (...args) => console.warn(...args),
  // Errors are kept in production for observability tools.
  error: (...args) => console.error(...args),
  debug: isProd ? noop : (...args) => console.debug(...args)
};

export default logger;
